import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const Icon = components.base.Icon.Icon;

const rawCssPrefix = `
img {
	visibility: hidden;
	opacity: 0;
	width: 25px;
	height: 25px;
	display: block;
	position: absolute;
	top: 50%;
	left: 50%;
	transition: visibility 300ms, opacity 300ms
}
`;

export default InjectedStyledComponent(Icon, 'app', ['spinner'], undefined, rawCssPrefix);
